import React from "react";

const Footer = () => {
  return (
    <footer className="page-footer font-small  pt-4">
      <div className="footer-copyright p-4 text-center">
        © {new Date().getFullYear()} Copyright: Westwind Property Maintenance
      </div>
    </footer>
  );
};

export default Footer;
